import { MenuContainer, Sidebar, Menu, MenuItem, LogoContainer } from "./MenuProduct.style";
import { Link, useParams } from "react-router-dom";
import LogoTegor from '../../assets/Lines/white-logos/tegor-blanco.png';
import LogoReckeweg from '../../assets/Products/Logos/dr-reckeweg-white.png';
import LogoHelixor from '../../assets/Lines/white-logos/helixor-blanco.png';
import LogoSymbiopharm from '../../assets/Lines/white-logos/symbio-blanco.png';
import LogoRegenhial from '../../assets/Lines/white-logos/regenhial-blanco.png';

const logoMapping = {
  'dr-reckeweg': LogoReckeweg,
  'tegor': LogoTegor,
  'helixor': LogoHelixor,
  'symbio-pharm': LogoSymbiopharm,
  'regenhial': LogoRegenhial
}

const MenuProduct = ({ productLines = [], lineId }) => {
  const { subCategory } = useParams();
  return (
    <MenuContainer brand={lineId} category={subCategory}>
      <Sidebar>
      <LogoContainer>
          <img src={logoMapping[lineId] || LogoReckeweg} alt={`${lineId} Logo`} />
        </LogoContainer>
        <h2>Menu</h2>
        <Menu brand={lineId}>
          {productLines.map((item) => (
            <MenuItem 
              as={Link} 
              to={`/lineas/${lineId}/${item.id}/${item.firstProductId}`} 
              key={item.id}
              className={subCategory === item.id ? 'active' : ''}
            >
              {item.name}
            </MenuItem>
          ))}
        </Menu>
      </Sidebar>
    </MenuContainer>
  );
};

export default MenuProduct;
